import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.div<{ $show: boolean; $items: number }>`
  height: ${({ theme, $items, $show }) =>
    $show ? `calc(${$items * 1.8}rem + ${theme.spacing(1)})` : 0};

  border-radius: ${({ theme }) => theme.spacing(2)};
  background: ${({ theme }) => theme.palette.grey[50]};
  overflow: hidden;
  transition: height 200ms;

  ${({ $show }) =>
    $show &&
    css`
      &:first-child {
        margin-top: ${({ theme }) => theme.spacing(6)};
      }
    `};
`;

export const List = styled.ul`
  list-style: none;

  margin: 0;
  padding: ${({ theme }) => `${theme.spacing(0.5)} 0`};
`;

export const ListItem = styled.li``;

export const EventContainer = styled.a`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  align-items: center;

  min-width: 0;
  padding: ${({ theme }) => `0 ${theme.spacing(1.5)}`};

  text-decoration: none;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const Color = styled.span<{ $color?: string }>`
  display: block;
  height: 1rem;
  width: 0.3rem;

  border-radius: ${({ theme }) => theme.spacing(0.5)};
  background: ${({ $color }) => $color ?? 'transparent'};
`;

export const Time = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
  min-width: 7.6rem;
  width: 7.6rem;
  max-width: 7.6rem;

  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Title = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.overline)};

  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme }) => theme.palette.text.primary};
`;
